import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

class OperationsSlider {
  constructor() {
    const slider = document.querySelector('.operations-slider__slider .swiper');

    if (slider) {
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
          1050: {
            slidesPerView: 2,
          }
        },
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
    }
  }
}

export default OperationsSlider;
